
    <usb-popup [isLoading]="false" [showAlways]="true">
      <div class="mb-3">
        <img class="fa-spin" width="40" height="40" src="../../../../assets/icons/SPINNER.svg" alt="Spinner" />
      </div>
      <h2 class="cancel-loader_title">Conectando</h2>
      <h3 class="cancel-loader_subtitle mb-2">Reserva</h3>
      <p class="cancel-loader_text">Por favor espere mientras obtenemos <br /> las respuestas</p>
    </usb-popup>
  